const MAX_PHONE_INPUT_FIELD = 3;

export default {
    MAX_PHONE_INPUT_FIELD
};
